
import {React , useEffect, Suspense} from 'react';
import AOS from 'aos';
import { Route, Routes } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import '../src/assets/font/font-awesome.css'
import './styles/swiper.css'
import routes from './pages';
import Login from './pages/Login';
import { useLocation } from 'react-router-dom';
import SEO from './components/SEO/SEO';
import { initPerformanceMonitoring, registerServiceWorker } from './utils/performance';

// Enhanced loading component for lazy routes
const PageLoader = () => (
    <div className="loading-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        flexDirection: 'column',
        width: '100%',
        textAlign: 'center'
    }}>
        <div className="loading-spinner" style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #1a73e8',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
        }}></div>
        <div className="loading-text" style={{
            marginTop: '16px',
            color: '#666',
            fontSize: '16px',
            textAlign: 'center'
        }}>
            Loading...
        </div>
    </div>
);

function App() {

    const location = useLocation();
    const isTradePath = location.pathname.startsWith('/trade');
 
    useEffect(() => {
        // Initialize AOS with performance optimizations
        AOS.init({
          duration: 1200,
          easing: 'ease-out-cubic',
          once: true, // Only animate once for better performance
          offset: 50,
          delay: 100
        }); 

        // Initialize performance monitoring
        initPerformanceMonitoring();
        
        // Register service worker
        registerServiceWorker();
        
        // Load trading charts if on trading page
        if (location.pathname.startsWith('/trade') && window.loadTradingCharts) {
            window.loadTradingCharts();
        }
        
        // Preload critical resources
        const preloadLinks = [
            { href: '/markets', as: 'document' },
            { href: '/trade/BTCUSDT', as: 'document' }
        ];
        
        preloadLinks.forEach(link => {
            const linkElement = document.createElement('link');
            linkElement.rel = 'prefetch';
            linkElement.href = link.href;
            linkElement.as = link.as;
            document.head.appendChild(linkElement);
        });
        
    }, [location.pathname]);

    return (
        <>
            <SEO />

            <Header />
           
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    {
                        routes.map((data,idx) => (
                            <Route key={idx} path={data.path} element={data.component}  />
                        ))
                    }
                    <Route path='*' element={<Login />} />
                </Routes>
            </Suspense>
            {
                isTradePath?(
                    <>
                    </>
                ):(
                    <>
                    <Footer />
                    </>
                )
            }
        </>
    );
}

// Add global CSS for animations
const globalStyles = `
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`;

// Inject global styles
if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.textContent = globalStyles;
    document.head.appendChild(styleElement);
}

export default App;
